import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce5a2dd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scan-wrap" }
const _hoisted_2 = { class: "van-hairline--bottom" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sn-title" }, "合约机序列号", -1))

import { Field } from 'vant'
import { clearToast, showConfirmModal, showToastLoading } from '@/utils/tools'
import { withDefaults, ref } from 'vue'
import { requestAddUnActivetedDevice } from '@/apis/agricultura-loan'
import appHost from '@/utils/app'
import PopupWrap from '@/components/popup/common-wrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import { commonErrorHandle } from '@/utils/error-handle'


export default /*#__PURE__*/_defineComponent({
  __name: 'unactived-device-popup',
  props: {
    visible: { type: Boolean, default: false },
    code: { default: '' }
  },
  emits: ['update:visible', 'confirm'],
  setup(__props: any, { emit: emits }) {

const props = __props as { visible: boolean, code: string };




const snValue = ref('')

function updateShowHandle(visible: boolean) {
  emits('update:visible', visible)
}
// 确认添加
async function confirmInput() {
  try {
    await showConfirmModal({
      title: '提示',
      message: '绑定合约机后该设备只能由借款人账号进行激活',
      confirmButtonText: '确定绑定',
      cancelButtonText: '取消',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
  } catch (error) {
    console.log('error', error)
  }
  showToastLoading()
  try {
    const data = await requestAddUnActivetedDevice({
      serial_number: snValue.value,
      material_code: props.code,
    })
    emits('confirm', {
      serial_number: snValue.value,
      name: data?.name || '',
      material_code: props.code,
    })
    snValue.value = ''
    updateShowHandle(false)
    clearToast()
  } catch (error) {
    commonErrorHandle(error)
  }
}
// 调用app扫码录入
async function getScanInfo() {
  const value = await appHost.openCameraToScanQrCode('序列号')
  if (value) {
    snValue.value = value
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrap, {
    show: props.visible,
    "safe-area-inset-bottom": "",
    title: "添加未激活的设备",
    headerStyle: {
      backgroundColor: 'white',
    },
    "onUpdate:show": updateShowHandle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(Field), {
            modelValue: snValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((snValue).value = $event)),
            placeholder: "请输入合约机序列号",
            "right-icon": "scan",
            class: "scan-field",
            onClickRightIcon: getScanInfo
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(CommonFooterNextButton, {
        title: "确定",
        onClick: confirmInput
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})